import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgGraphIconSecondary from './svgs/GraphIconSecondary.js';
import { useIcon } from '../../shared-components/icon/index.js';

var graphIcon = (props => useIcon(null, SvgGraphIconSecondary, props));

export { graphIcon as default };
